import {dropbox_os} from '@dropbox/api-v2-client';
import {CurrentEnvironment, getCurrentEnvironment} from 'helpers/environment';

export const appPlatformEnvironmentFor = (
  environment: CurrentEnvironment
): dropbox_os.AppPlatformEnvironment =>
  environment === CurrentEnvironment.Production
    ? {'.tag': 'app_platform_environment_production'}
    : {'.tag': 'app_platform_environment_staging'};

export const getAppPlatformEnvironment = (): dropbox_os.AppPlatformEnvironment =>
  appPlatformEnvironmentFor(getCurrentEnvironment());
